import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { TopicAction } from '@stores/topic/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav  from '@components/tabNav';
import TabFilter  from '@components/tabFilter';
import ThreadList from '@components/threadList';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import AvatarList from '@components/avatarList';
import { Carousel } from 'antd';


interface TopicThreadListH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topic?: TopicAction;
    handleSetState: any
}
interface TopicThreadListH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    userList: any
}
@inject('app', 'site', 'user', 'topic')
@observer
class TopicThreadListH5Page extends BasePage<TopicThreadListH5PageProps, TopicThreadListH5State> {
     state = {
        loading: false,
        error: null,
        pageLoaded: false,
        userList: [],  // 版主用户列表
    };
    async componentDidMount() {
        const { app, user, topic } = this.props;
        // 
        
        // let topicId = 300004;
        // if(topic) {
        //     let params:any = {
        //         "page[number]": 1,
        //         "page[size]": 20
        //     }
        //     await topic.getTopicThreadList(topicId, params).then((res:any )=> {
        //         
        //         
                
        //         if ((res).data?.topic) {
        //             // this.setState({
        //             //     topisDetail: (res).data.topic  // 这里可以安全访问
        //             // });
        //         } else {
        //             
        //         }
        //     }).catch(error => {
        //         
        //     });
            
        // }
        super.componentDidMount();
    }

    // 立即下载
    downloadClick = (id: string | number) => {
        // this.props.history && this.props.history.push(`/topic/${id}`);
    };

    // 帖子列表
    renderThreadList = () => {
        const { topic } = this.props;
        if (!topic || !topic.listStore) return null;
        const list = topic.listStore.lists['topicThreadList'];
        if (!list) return null;
        const flatList = topic.listStore.getList({ namespace: 'topicThreadList' });
        return (
            <div className={styles.threadListBox}>
                <ThreadList 
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    onLoadMore={this.handleLoadMore}
                    namespace="topicThreadList"
                    listStore={topic.listStore}
                ></ThreadList>
                {/* {list.loading && <div className={styles.loading}>加载中...</div>}
                {!list.hasMore && !list.loading && <div className={styles.loading}>没有更多了</div>}
                {list.requestError.isError && <div className={styles.loading}>{list.requestError.errorText}</div>} */}
            </div>
        )
    }

    // 加载下一页数据
    handleLoadMore = () => {
        const { topic } = this.props;
        if (!topic) return;

        const list = topic.listStore.lists['topicThreadList'];
        if (!list) return;

        const currentPage = list.attribs?.currentPage || list.attribs?.page || 1;
        const nextPage = currentPage + 1;
        const pageSize = list.attribs?.pageSize || 20;

        

        let params: any = {
            "page[number]": nextPage,
            "page[size]": pageSize
        }

        topic.getTopicThreadList(params).then((res: any) => {
            
        }).catch(error => {
            
        });
    }
    // 类型切换
    // navClick = (item:any, index:any) => {
    //     
    //     // this.handleSetState({
    //     //     navCurrentIndex: index
    //     // })
    // }

    // // 筛选切换
    // filterClick = (item:any, index:any) => {
    //     
    //     // this.setState({
    //     //     filterCurrentIndex: index
    //     // })
    // }


    render() {
        let { userList } = this.state
        // const { topic } = this.props;
        return ( <div className={styles.wrapper}>
            <div className={styles.topicDetailBox}>
                {this.renderThreadList()}
            </div>
            
            
        </div>)
    }
}

export default withRouter(TopicThreadListH5Page);
